export default "__VITE_ASSET__C8iCv2Gv__"